var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-breadcrumbs',{staticClass:"mb-0 ml-0 pb-0 pl-0",attrs:{"items":_vm.breadcrumbList}}),_c('h1',[_vm._v(_vm._s(_vm.title))])],1)],1),_c('v-row',[_c('v-col',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }